import { ThemeProvider } from '@emotion/react';
import { createTheme } from '@mui/material/styles';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import axios from 'axios';
import App from './App';
import './index.scss';
import { setUrlPathFromDomain } from './services/utils/utils';
import alarmeReducer from './services/reducteurs/alarme';
import alertesReducer from './services/reducteurs/alertes';
import tasksReducer from './services/reducteurs/tasks';
import attenteRequeteReducer from './services/reducteurs/attenteRequete';
import authReducer from './services/reducteurs/auth';
import capteurReducer from './services/reducteurs/capteur';
import exportImpressionEcranReducer from './services/reducteurs/exportImpressionEcran';
import grapheReducer from './services/reducteurs/graphe';
import interfaceClientReducer from './services/reducteurs/interfaceClient';
import maintenanceReducer from './services/reducteurs/maintenance';
import popupReducer from './services/reducteurs/popup';
import privilegeReducer from './services/reducteurs/privilege';
import rapportReducer from './services/reducteurs/rapport';
import utilisateurReducer from './services/reducteurs/utilisateur';
import vueReducer from './services/reducteurs/vue';
import accueilReducer from './services/reducteurs/accueil';
import * as serviceWorker from './serviceWorker';

// const composeEnhancers = compose;
const composeEnhancers =
  process.env.NODE_ENV === 'development'
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : null || compose;

let cheminURLAPI = setUrlPathFromDomain(
  'http://localhost/argos_frontend/api_argos/api.php',
  'https://argos-v19.itmsol.fr/index.php',
  'https://argos-v25.itmsol.fr/index.php',
  'https://argos-dev.itmsol.fr/index.php'
);

axios.defaults.baseURL = cheminURLAPI;

// Intercepteur pour éviter les boucles infinies - DÉSACTIVÉ TEMPORAIREMENT
// let requestQueue = new Map();

// axios.interceptors.request.use(
//   (config) => {
//     const requestKey = `${config.method}:${config.url}`;
//     const now = Date.now();

//     // Vérifier si une requête identique a été faite récemment (moins de 1 seconde)
//     if (requestQueue.has(requestKey)) {
//       const lastRequestTime = requestQueue.get(requestKey);
//       if (now - lastRequestTime < 1000) {
//         console.warn('Requête en double détectée (< 1s), annulation:', requestKey);
//         return Promise.reject(new Error('Duplicate request cancelled'));
//       }
//     }

//     requestQueue.set(requestKey, now);

//     // Nettoyer les anciennes entrées (plus de 10 secondes)
//     setTimeout(() => {
//       if (requestQueue.has(requestKey) && now - requestQueue.get(requestKey) > 10000) {
//         requestQueue.delete(requestKey);
//       }
//     }, 10000);

//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.code === 'ERR_INSUFFICIENT_RESOURCES') {
      console.error('Erreur de ressources insuffisantes détectée');
      return Promise.reject(new Error('Server overloaded, request cancelled'));
    }
    return Promise.reject(error);
  }
);
const rootReducer = combineReducers({
  authentifie: authReducer,
  alrt: alertesReducer,
  utilisateur: utilisateurReducer,
  capteur: capteurReducer,
  graphe: grapheReducer,
  vue: vueReducer,
  alarme: alarmeReducer,
  rapport: rapportReducer,
  functions: tasksReducer,
  privilegeUtilisateur: privilegeReducer,
  attenteRequete: attenteRequeteReducer,
  popup: popupReducer,
  interfaceClient: interfaceClientReducer,
  exportImpressionEcran: exportImpressionEcranReducer,
  maintenance: maintenanceReducer,
  accueil: accueilReducer,
});

export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

const theme = createTheme({
  palette: {
    primary: {
      light: '#757ce8',
      main: '#3C3935',
      dark: '#002884',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff7961',
      main: '#f44336',
      dark: '#ba000d',
      contrastText: '#000',
    },
  },
});

ReactDOM.render(
  <BrowserRouter
    getUserConfirmation={(message, callback) => {
      // this is the default behavior
      const allowTransition = window.confirm(message);
      callback(allowTransition);
    }}
  >
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Provider>
  </BrowserRouter>,
  document.getElementById('root')
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
